<template>
	<div class="orderpage">
		<common-header></common-header>
		<div class="text-left flex border-top">
			<div class="left-menu">
				<ul class="side-nav">
					<li class="nav-item">
						<a>个人中心</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage')">个人中心</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>我的关注</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/userManage/collect')">商品收藏</el-link></li>
						</ul>
					</li>
					<li class="nav-item">
						<a>订单中心</a>
						<ul>
							<li class="nav-item"><el-link @click="toPage('/order','state=1')">待付款</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order','state=2')">待发货</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order','state=3')">待评价</el-link></li>
							<li class="nav-item"><el-link @click="toPage('/order','state=4')">退款售后</el-link></li>
						</ul>
					</li>
				</ul>
			</div>
			<div class="right-container">
				<div class="page-title backcolor padding">我的卡包</div>
				<div class="order-container">
					<template v-if="couponList.length">
						<div class="coupon-list">
							<div
								class="coupon-item"
								v-for="(item, index) in couponList"
								:key="index"
								:class="total < item.min_pay ? 'discanuse' : ''"
							>
								<div class="con">
									<div class="left">
										<span class="title">{{ item.name }}</span>
										<span class="time">有效期{{ ctimeToDay(item.start_time) }}至{{ ctimeToDay(item.end_time) }}</span>
									</div>
									<div class="right">
										<span class="price">
											<span v-if="item.youhui_bili > 0">
												{{ item.youhui_bili * 10 }}
												<span style="font-size: 13px;">折</span>
											</span>
											<span v-else>{{ item.youhui_price }}</span>
										</span>
										<span v-if="item.min_pay > 0">满{{ item.min_pay }}可用</span>
										<span v-else>无门槛</span>
									</div>
						
									<div class="circle l"></div>
									<div class="circle r"></div>
								</div>
								<!-- <text class="tips" :class="item.id == coupon_checkId ? 'coupon_checked' : ''">{{ user_type_text(item.user_type) }}</text> -->
								<div class="tips flex">
									<span>{{ user_type_text(item.user_type) }}</span>
									<span v-if="item.goods_category">限{{ item.goods_category_name }}类使用</span>
									<span v-if="item.apply_goods_ids.length" @click.stop="showApplyGoods(item.apply_goods)">
										自定义商品可用
										<span style="margin-left: 7px;color: #007AFF;">查看</span>
									</span>
									<!-- <span v-if="!item.goods_category&&!item.apply_goods_ids.length">{{user_type_text(item.user_type)}}</span> -->
									<div>
										<el-button type="danger" size="mini" style="margin-top: 5px;" class="getTicketBtn" @click="toPage('/home')">去使用</el-button>
									</div>
								</div>
							</div>
						</div>
					</template>
					<div v-else class="text-center backcolor" style="color: #ccc;height: 300px;padding-top: 130px;">
						<template v-if="loaded">
							<i class="el-icon-s-ticket" style="font-size: 48px;"></i>
							<p>卡包里暂无优惠券，去<el-link @click="toPage('/userManage/couponCenter')">领券中心</el-link>看看吧</p>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import commonHeader from '../../components/common/commonHeader.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
	name: '',
	components: {
		commonHeader
	},
	data() {
		return {
			thispage: 1,
			total: 0,
			pagesize: 30, //每页显示条数
			pageSizes: [30], //每页显示个数选择器
			couponList: [],
			loaded:false,
		};
	},
	computed: {
		...mapState({
			loginState: state => state.user.loginState,
			userInfo: state => JSON.parse(state.user.userInfo)
		})
	},
	mounted() {
		this.getCouponList();
	},
	methods: {
		getCouponList() {
			this.$emit('showLoading',true);
			this.$request
				.post('/home.user/getCouponList', {
					userid: this.userInfo.id,
					token: this.userInfo.token,
				})
				.then(res => {
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.couponList = res.data.couponList;
						for (let i in this.couponList) {
							this.couponList[i].apply_goods = JSON.parse(this.couponList[i].apply_goods);
							this.couponList[i].apply_goods_ids = JSON.parse(this.couponList[i].apply_goods_ids);
						}
						this.loaded = true;
					}
					this.$emit('showLoading',false);
				})
				.catch(err => {
					this.$emit('showLoading',false);
				});
		},
		user_type_text(type) {
			switch (type) {
				case 1:
					return '全体用户可用';
					
				case 2:
					return '限新用户使用';
					
				case 3:
					return '限会员用户使用';
					
				case 4:
					return '限分销员使用';
					
				default:
					return '全体用户可用';
					
			}
		},
		getCouponById(id,index){
			console.log(id,index);
			this.$emit('showLoading',true);
			this.$request.post('/home.user/getCouponById',{
					couponId:id,
					userid:this.userInfo.id,
					token:this.userInfo.token
				})
				.then(res=>{
					this.$emit('showLoading',false);
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						if(res.data.status == 1){
							this.$message.success(res.data.msg);
							this.couponList.splice(index,1);
						}
					}
					
				})
				.catch(err=>{
					this.$emit('showLoading',false);
				})
		},
		//删除订单
		deleteOrder(item) {
			this.$confirm('确定要取消订单吗？')
				.then(_ => {
					this.$emit('showLoading', true);
					this.$request
						.post('/home.order/deleteOrder', {
							userid: this.userInfo.id,
							token: this.userInfo.token,
							order_id: item.id,
							buyType: '' //区别于团购订单的
						})
						.then(res => {
							console.log(res.data);
							this.$emit('showLoading', false);
							this.$message.success(res.data.msg);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'userinfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.getCollectList();
							}
						})
						.catch(err => {
							this.$emit('showLoading', false);
						});
				})
				.catch(_ => {});
		},
	}
};
</script>
<style lang="scss">
.el-main {
	.orderpage {
		background-color: #f0f3ef !important;
	}
	.left-menu {
		width: 170px;
		// flex-shrink:0;
		background-color: #fff;
		.side-nav {
			> .nav-item {
				padding: 15px 20px;
				border-bottom: 1px solid #f3f3f3;
				a {
					font-size: 15px;
					font-weight: bold;
					text-decoration: none;
					line-height: 40px;
				}
				.nav-item {
					a {
						font-size: 14px;
						line-height: 30px;
						&:hover {
							cursor: pointer;
						}
					}
				}
			}
		}
	}
	.right-container {
		flex: 1;
		padding: 20px 0 0 20px;
		background-color: #f0f3ef !important;
		.backcolor {
			background-color: #fff;
		}
		.padding {
			padding: 0 15px;
		}
		.page-title {
			line-height: 40px;
		}
		.order-container {
			margin-top: 15px;
			// margin-left: 15px;
			.menu-btn {
				button {
					color: dimgray;
					padding: 0 10px;
					line-height: 35px;
					&:hover {
						color: $base-color;
					}
					&.active {
						color: $base-color;
						border-bottom: 2px solid $base-color;
					}
				}
			}
			.order-item {
				margin-top: 10px;
				border: 1px solid #dddddd;
				.th {
					background-color: #e1e1e1;
					font-size: 14px;
					line-height: 35px;
					span + span {
						margin-left: 15px;
					}
				}
				.item-border {
					> div {
						border-right: 1px solid #dddddd;
						padding-top: 15px;
						text-align: center;
						&:first-child{
							padding:  0 15px;
							text-align: left;
						}
						&:first-child {
							padding-top: 0;
						}
						&:last-child {
							border-right: none;
						}
					}
				}
				.goods-info {
					flex: 1;
					.goods-item {
						border-bottom: 1px solid #dddddd;
						&:last-child {
							border: none;
						}
						padding: 15px 0;
						.smpic {
							width: 60px;
							height: 60px;
						}
						.goods-title {
							flex: 1;
							padding-left: 15px;
						}
						.param-num {
							padding: 0 15px;
							text-align: center;
							color: gray;
							font-size: 14px;
							line-height: 30px;
							.num {
								&::before {
									content: 'x';
									margin-right: 3px;
								}
							}
						}
					}
				}

				.user-address {
					width: 85px;
					line-height: 30px;
					&:hover {
						cursor: pointer;
					}
				}
				.order-pay {
					width: 90px;
					line-height: 30px;
					text-align: center;
					.pay {
						border-bottom: 1px solid #ccc;
						&::before {
							content: '￥';
						}
					}
				}
				.order-status{
					width: 82px;
				}
				.operate {
					width: 120px;
					text-align: center;
					.chaoshi_tip {
						font-size: 13px;
						color: #cccccc;
					}
					.block{
						display: block;
						+.block{
							margin-top: 10px;
						}
					}
					
				}
			}
		}
	}
	.border-top{
		border-top:1px solid #f3f3f3 ;
	}
}
</style>
